__webpack_require__.p = "/Speed-Typer-Pro/";